import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
export default class ClientService extends ApiService {
  // defaultTemplate
  namespace = "client";
  name = "Client";
  DOMAIN = 76;
  Width = 1000;

  template = "defaultTemplate";
  icon = "Community";
  favicon = "BlueSilhouette";
  action = "action";

  columns = [
    {
      header: this.t("displayName"),
      icon: "Tag",
      field: "display_name",
    },
    {
      header: this.t("status"),
      icon: "Tag",
      field: "status",
      template: (data) => {
        return this.parseStatus(data["status"]);
      },
    },
    {
      header: this.t("updatedAt"),
      icon: "Tag",
      field: "updated_at",
      template: (data) => {
        return this.parseDate(data["updated_at"]);
      },
    },
  ];

  gemItems = [
    {
      key: "create",
      label: this.t("addAEntity", { entity: "Client" }),
      icon: PrimeIcons.PLUS_CIRCLE,
    },

    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: "Clients" }),
      icon: PrimeIcons.LIST,
    },
    {
      key: "bookmarks",
      label: this.t("viewBookmarkEntity", { entity: "Client" }),
      icon: PrimeIcons.LIST,
    },
  ];

  filterItems = [
    {
      name: "Associations",
      value: "association",
      folder: ["Association 1", "Association 2"],
    },
    { name: "Folder", value: "folder", folder: ["folder 1", "folder2"] },
  ];

  parseStatus(status) {
    let value = "";
    switch (status) {
      case 8:
        value = "Rejected";
        break;
      case 9:
        value = "Inactive";
        break;
      case 10:
        value = "Active";
        break;
      case 11:
        value = "Waiting For Approval";
        break;
      case 12:
        value = "Approved";
        break;
      case 13:
        value = "Processing";
        break;
      case 15:
        value = "Pending";
        break;
      default:
        value = "Deleted";
        break;
    }
    return value;
  }
  buildUrl(client) {
    return "//" + client.slug + ".epicai.com/";
  }
  buildLoginUrl(client, creds) {
    return this.buildUrl(client) + "login?auth=" + creds.auth_key;
  }
  constructor() {
    super("clients");
  }
}
